export default function VideoSection() {
  return (
    <section className="pb-20 bg-white">
      <div className="max-w-4xl mx-auto px-6">
        <div className="text-center mb-10">
          <h2 className="text-3xl font-black text-[#000000] leading-tight mb-3">
            Conheça a Nossa História
          </h2>
          <p className="text-[#000000]/60 text-base">
            Assista ao vídeo e saiba mais sobre quem somos e o que fazemos.
          </p>
        </div>
        <div
          className="relative w-full overflow-hidden rounded-2xl"
          style={{ paddingTop: "56.25%" }}
        >
          <iframe
            className="absolute inset-0 w-full h-full"
            src="https://www.youtube.com/embed/ftNEpFaO2uw?si=JJjFACPasc7uTeBx"
            title="Vídeo institucional"
            frameBorder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            allowFullScreen
          />
        </div>
      </div>
    </section>
  );
}
